<template>
    <div :style="containerStyle">
        <b-form-invalid-feedback
            :key="validation.text"
            :state="validation.show"
            v-for="validation in validationsToShow"
        >
            {{ validation.text }}
        </b-form-invalid-feedback>
    </div>
</template>
<script>
import i18n from '@/i18n'
export default {
    props: {
        textRight: {
            type: Boolean,
            default: false,
        },
        itemsValidations: {
            type: Array,
            required: true,
        },
    },
    computed: {
        containerStyle() {
            return this.textRight ? 'text-align: right !important' : ''
        },
        validationsText() {
            return {
                decimal: i18n.t('form.validations.numeric'),
                minValue: i18n.t('form.validations.minValue', { value: 0 }),
                quadrantsLimits: i18n.t(
                    'nBox.form.validations.quadrantsLimits'
                ),
            }
        },
        validationsToShow() {
            const validationKeys = ['minValue', 'decimal', 'quadrantsLimits']
            return validationKeys.reduce((result, key) => {
                const hasSomeInvalidItem = this.itemsValidations.every(
                    item => item[key] !== false
                )
                result[key] = {
                    show: hasSomeInvalidItem,
                    text: this.validationsText[key],
                }

                return result
            }, {})
        },
    },
}
</script>
